<template>
  <main class="wrapper-content">
    <h1>{{ $t('qms_totems') }}</h1>
    <template v-if="!isLoading">
      <b-card class="border">
        <b-row>
          <LmTextInput
            class="col-12"
            :label="$t('name')"
            :placeholder="$t('enter_name')"
            v-model="$v.form.name.$model"
            :v="v('form.name')"
          />
          <LmTextArea
            class="col-12"
            :label="$t('description')"
            :placeholder="$t('enter_description')"
            v-model="form.description"
            :v="v('form.description')"
          />
        </b-row>
      </b-card>

      <b-card no-body class="border">
        <b-tabs card>
          <b-tab :title="$t('general')" active>
            <LmDatatableWithModalSelector
              datatableSlug="sucursales-modal-single-internal"
              datatableModalSlug="sucursales-modal-single-internal"
              @itemsAdded="onAddBranchOffices"
              @itemsToRemove="onRemoveBranchOffices"
              :hideTableSearcher="true"
              :hideTableFilter="true"
              :hideTableButtons="false"
              :items="form.branchoffices"
              :addItemButtonLabel="$t('add')"
              :emptyItemsMessage="$t('no_branchoffices_selected')"
              :removeConfirmationMessage="$t('branch_offices_remove_confirmation')"
            />
          </b-tab>
          <b-tab :title="$t('qms_processes')">
            <LmDatatableWithModalSelector
              datatableSlug="tramites-modal-internal"
              datatableModalSlug="tramites-modal-internal"
              @itemsAdded="onAddProcesses"
              @itemsToRemove="onRemoveProcesses"
              :hideTableButtons="false"
              :items="form.processes"
              :addItemButtonLabel="$t('add')"
              :emptyItemsMessage="$t('no_subprocesses_selected')"
              :removeConfirmationMessage="$t('subprocesses_remove_confirmation')"
            />
          </b-tab>
          <b-tab :title="$t('screens')">
            <!-- FormBuilderUi -->
            <div id="lm-form-builder-ui" class="wrapper-content w-100 px-0 mt-3">
              <div class="row position-relative">
                <div class="col-12">
                  <h3>Pantallas asociadas</h3>
                  <draggable
                    v-model="form.screens"
                    @start="drag=true"
                    @end="drag=false"
                    animation="150"
                    handle=".handle"
                    >
                    <div v-for="(screen, index) in form.screens" :key="screen.id" class="mt-4">
                      <header
                        class="d-flex justify-content-between align-items-center bg-primary text-white px-3 handle shadow rounded-lg bg-info">
                        <font-awesome-icon class="mr-4" icon="arrows-alt" style="width:18px; height:18px;" />
                        <h4 v-b-toggle="`collapse-screen-${index}`" class="flex-grow-1 text-center my-0 py-3 handle">{{form.screens[index].title}}</h4>
                        <div class="d-flex align-items-center">
                          <font-awesome-icon v-b-toggle="`collapse-screen-${index}`" class="collapse-formsection-up ml-4 clickable" icon="chevron-up" style="width:16px; height:16px;" />
                          <font-awesome-icon v-b-toggle="`collapse-screen-${index}`" class="collapse-formsection-down ml-4 clickable" icon="chevron-down" style="width:16px; height:16px;" />
                          <font-awesome-icon class="ml-4 clickable" icon="trash" @click="removeScreenElement(index)" style="width:16px; height:16px;" />
                        </div>
                      </header>
                      <b-collapse
                        accordion="screen-accordion"
                        :id="`collapse-screen-${index}`"
                        visible
                        class="p-4 border border-top-0 rounded-lg bg-white"
                        >
                          <div class="row">
                            <LmTextInput
                              class="col-12"
                              :label="$t('name')"
                              :placeholder="$t('enter_name')"
                              v-model="form.screens[index].title"
                            />
                          </div>

                          <h3>Diseño de la pantalla</h3>
                          <div class="row" v-if="componentsOptions.content.length">
                            <div class="col-12 col-md-6 px-0 formbuilder-component-section border-top border-right" v-show="modes.editView">
                              <LmSvgIcon
                                v-if="form.screens[index].formElements.length === 0"
                                wrapperClass="d-flex mt-4 justify-content-center align-items-center flex-column"
                                width="18em"
                                icon="LmSettingsIcon"
                                text="Creá el formulario agregando los campos que desees"
                              />
                              <div class="col-12">
                                <!-- TODO Agregar botón Agregar Fila  -->
                                <LmButton
                                    id="add-field-button"
                                    class="mt-4"
                                    type="button"
                                    buttonClass="btn-info"
                                    lmButtonRootWrapperClass="d-inline-block"
                                    lmButtonWrapperClass="col"
                                    :value="$t('Agregar fila')"
                                  />
                              </div>
                              <LmForm ref="lmFormBuilderRef" id="documentFormElements">
                                <draggable
                                  class="col-12"
                                  v-model="form.screens[index].formElements"
                                  @start="drag=true"
                                  @end="drag=false"
                                  animation="150"
                                  handle=".handle"
                                  >
                                  <div v-for="(formElement, subindex) in form.screens[index].formElements" :key="formElement.id" class="mt-4">
                                    <header
                                      class="d-flex justify-content-between align-items-center bg-primary text-white px-3 handle shadow rounded-lg"
                                      :class="{'bg-info': !shouldCreatePortal(form.screens[index].formElements[subindex].componentName)}">
                                      <font-awesome-icon v-if="isEditable" class="mr-4" icon="arrows-alt" style="width:18px; height:18px;" />
                                      <h4 v-b-toggle="`collapse-formelements-${index}-${subindex}`" class="flex-grow-1 text-center my-0 py-3 handle">{{title(form.screens[index].formElements[subindex])}}</h4>
                                      <div v-if="shouldCreatePortal(form.screens[index].formElements[subindex].componentName)" class="circle d-flex justify-content-center align-items-center">{{subindex}}</div>
                                      <div class="d-flex align-items-center">
                                        <font-awesome-icon v-b-toggle="`collapse-formelements-${index}-${subindex}`" class="collapse-formsection-up ml-4 clickable" icon="chevron-up" style="width:16px; height:16px;" />
                                        <font-awesome-icon v-b-toggle="`collapse-formelements-${index}-${subindex}`" class="collapse-formsection-down ml-4 clickable" icon="chevron-down" style="width:16px; height:16px;" />
                                        <font-awesome-icon v-if="isEditable" class="ml-4 clickable" icon="trash" @click="removeQmsFormElement(index, subindex)" style="width:16px; height:16px;" />
                                      </div>
                                    </header>
                                    <b-collapse
                                      accordion="component-accordion"
                                      :id="`collapse-formelements-${index}-${subindex}`"
                                      visible
                                      class="p-4 border border-top-0 rounded-lg bg-white"
                                      >
                                      <LmSelect
                                        :id="'select-elements-' + subindex"
                                        v-model="form.screens[index].formElements[subindex].componentName"
                                        :options="componentsOptions"
                                        :label="$t('select_elemet_type')"
                                        @input="selectorElementForm($event, subindex, index)"
                                      />
                                      <component
                                        :index="subindex"
                                        :is="whatComponentBuilderUse(form.screens[index].formElements[subindex].componentName)"
                                        :id="form.screens[index].formElements[subindex].id"
                                        :componentData="form.screens[index].formElements[subindex]"
                                        :screens="form.screens"
                                        :availableProcesses="availableProcesses"
                                        :options="lmSuperPowerSelectV2BuilderUiOptions"
                                        :isOnEditMode="isOnEditMode"
                                        @input="inputHandler($event, index, subindex)"
                                        @validations-changes="validationsChangesHandler"
                                        v-bind="$attrs"
                                        :isVisibleCondition="false"
                                      />
                                    </b-collapse>
                                  </div>
                                </draggable>
                                <div class="col-12">
                                  <LmButton
                                    v-if="isEditable"
                                    id="add-field-button"
                                    class="mt-4"
                                    type="button"
                                    buttonClass="btn-primary"
                                    lmButtonRootWrapperClass="d-inline-block"
                                    lmButtonWrapperClass="col"
                                    @click.native="addFormElement(index, form.screens[index].formElements.length)"
                                    :value="$t('add_component')"
                                  />
                                </div>
                              </LmForm>
                            </div>
                            <!-- Preview del formbuilder que se generará -->
                            <div class="col-12 pt-4 formbuilder-preview-section border-top" :class="{ 'col-md-6': modes.editView }">
                              <LmQmsFormBuilder
                                class="px-0"
                                :logo="form.logo"
                                :getComponents="form.screens[index]"
                                :isOnPreviewMode="modes.editView"
                                @openEditFormElement="openEditFormElement"
                              />
                            </div>
                          </div>
                      </b-collapse>
                    </div>
                  </draggable>
                  <LmButton
                    id="add-field-button"
                    class="mt-4"
                    type="button"
                    lmButtonRootWrapperClass="d-inline-block"
                    lmButtonWrapperClass="col"
                    @click.native="addScreenElement()"
                    :value="$t('add_screen')"
                  />
                </div>
              </div>
            </div>
            <!-- FormBuilderUi -->
          </b-tab>
          <b-tab :title="$t('personalization')">
            <b-card class="border">
              <div class="col-12 overlay-image">
                <span class="d-block mb-2">{{$t('header_logo')}}</span>
                <div class="img-wrap mt-2" v-if="logoPath">
                  <b-img class="img-preview" center thumbnail :src="logoPath"></b-img>
                  <div class="img-description-layer">
                    <p v-b-modal.logo-cropper-modal class="img-description">{{$t('change_logo')}}</p>
                    <font-awesome-icon class="ml-4 clickable img-description" icon="trash" @click="onRemoveLogo()" style="width:16px; height:16px;" />
                  </div>
                </div>
                <div
                  v-else
                  class="empty-logo d-flex justify-content-center align-items-center">
                  <p v-b-modal.logo-cropper-modal class="mb-0">{{$t('click_to_change_logo')}}</p>
                </div>
              </div>
            </b-card>
          </b-tab>
        </b-tabs>
      </b-card>

      <b-row>
        <LmButton
          class="col-auto"
          buttonClass="btn-secondary"
          :value="$t('go_back')"
          @click="onCancel"
          :isProcessing="isProcessing"
        />
        <LmButton
          class="col-auto"
          buttonClass="btn-primary"
          :value="$t('save')"
          @click="onSubmit"
          :isProcessing="isProcessing"
        />
        <LmButton
          v-if="isOnEditMode && !deleted"
          class="col-auto"
          :requireConfirmation="true"
          :confirmationTitle="$t('you_are_about_to_delete')"
          buttonClass="btn-danger"
          :value="$t('delete')"
          @click="onDelete"
          :isProcessing="isProcessing"
        />
        <LmButton
          v-if="isOnEditMode && deleted"
          value="Reactivar"
          class="col-auto"
          :requireConfirmation="true"
          :confirmationTitle="$t('you_are_about_to_reactivate')"
          buttonClass="btn-success"
          @click="onReactivate()"
          :isProcessing="isProcessing"
        />
      </b-row>
    </template>
    <b-row v-else>
      <b-col><b-skeleton type="input"></b-skeleton></b-col>
      <b-col><b-skeleton type="input"></b-skeleton></b-col>
      <b-col md="12" class="my-4">
        <div>
          <div class="d-flex flex-wrap mb-3" style="gap: 1rem">
            <span
              class="p-2 border rounded-lg d-flex align-items-center justify-content-between"
              style="gap: 1rem"
              v-for="(item, index) in 4"
              :key="index"
            >
              <b-skeleton type="avatar"></b-skeleton>
              <b-skeleton width="100px"></b-skeleton>
            </span>
          </div>
          <b-skeleton type="button" width="150px"></b-skeleton>
        </div>
      </b-col>
    </b-row>
    <b-modal id="logo-cropper-modal" no-close-on-backdrop :title="$t('image_editor')" size="xl">
      <div id="image-for-avatar-wrapper" class="row">
        <div class="col-12">
          <LmProfileCropper
            ref="lmCropperLogo"
            hideSaveButton
            hideCropButton
            hideCropImg
            imgToCropWidthAsContainer
            :viewMode="1"
            :labelFile="$t('header_logo')"
            @input="form.logo = $event; closeCropper('logo-cropper-modal', 'lmCropperLogo');"
            @imageLoadedToBeCrop="isImageLoadedToBeCrop = true"
            @reset="isImageLoadedToBeCrop = false"
            :imgSrc="imageToCrop"
            />
        </div>
      </div>
      <template v-slot:modal-footer>
        <div class="w-100">
          <LmButton
            :disabled="!isImageLoadedToBeCrop"
            id="btn-crop-save-avatar"
            type="button"
            lmButtonRootWrapperClass="d-inline-block mr-1 mt-3"
            buttonClass="btn-primary"
            value="Guardar"
            class="float-right"
            @click="cropImage('lmCropperLogo')"
          />
          <LmButton
            id="btn-crop-cancel-avatar"
            type="button"
            lmButtonRootWrapperClass="d-inline-block mr-1 mt-3"
            buttonClass="btn-secondary"
            :value="$t('Cancel')"
            class="float-right"
            @click="closeCropper('logo-cropper-modal', 'lmCropperLogo')"
          />
        </div>
      </template>
    </b-modal>
  </main>
</template>

<script>
// Components
import LmTextInput from '@/components/form/elements/LmTextInput'
import LmButton from '@/components/form/elements/LmButton'
import LmTextArea from '@/components/form/elements/LmTextArea'
import LmDatatableWithModalSelector from '@/components/LmDatatableWithModalSelector'
import LmSuperPowerSelectV2 from '@/components/form/elements/LmSuperPowerSelectV2'
import LmTreeSelect from '@/components/form/elements/LmTreeSelect'
import LmQmsFormBuilder from '@/components/LmQmsFormBuilder'
import LmForm from '@/components/form/LmForm'
import LmCheckbox from '@/components/form/elements/LmCheckbox'
import LmSelect from '@/components/form/elements/LmSelect'
import LmRadio from '@/components/form/elements/LmRadio'
import draggable from 'vuedraggable'
import LmButtonV2 from '@/components/form/elements/LmButtonV2'
import LmProfileCropper from '@/components/LmProfileCropper.vue'

// QMS Components
import LmQmsButton from '@/components/form/elements/LmQmsButton'
import LmQmsNumberInput from '@/components/form/elements/LmQmsNumberInput'
import LmQmsWatch from '@/components/form/elements/LmQmsWatch'

// Formbuilder Components
import LmTextNumberEditorTextAreaPasswordBuilderUi from '@/components/lmFormBuilderUi/LmTextNumberEditorTextAreaPasswordBuilderUi'
import LmEmailInputBuilderUi from '@/components/lmFormBuilderUi/LmEmailInputBuilderUi'
import LmFormSubtitlesBuilderUi from '@/components/lmFormBuilderUi/LmFormSubtitlesBuilderUi'
import LmFormEmptySpaceBuilderUi from '@/components/lmFormBuilderUi/LmFormEmptySpaceBuilderUi'
import LmFormSeparatorBuilderUi from '@/components/lmFormBuilderUi/LmFormSeparatorBuilderUi'
import LmSelectBuilderUi from '@/components/lmFormBuilderUi/LmSelectBuilderUi'
import LmColorPickerBuilderUi from '@/components/lmFormBuilderUi/LmColorPickerBuilderUi'
import LmPageBreakBuilderUi from '@/components/lmFormBuilderUi/LmPageBreakBuilderUi'

// QMS Builder Components
import LmQmsButtonBuilderUi from '@/components/lmFormBuilderUi/LmQmsButtonBuilderUi'
import LmQmsNumberInputBuilderUi from '@/components/lmFormBuilderUi/LmQmsNumberInputBuilderUi'
import LmQmsWatchBuilderUi from '@/components/lmFormBuilderUi/LmQmsWatchBuilderUi'

// Mixins
import LmFormBuilderUi from '@/mixins/lmFormBuilderUi.js'
import lmToasts from '@/mixins/lmToasts'

// Utils
import commonsApi from '@/api/commons'
import _ from 'lodash'
import { required } from 'vuelidate/lib/validators'

export default {
  mixins: [lmToasts, LmFormBuilderUi],
  components: {
    LmForm,
    LmCheckbox,
    LmSelect,
    LmRadio,
    LmTextInput,
    LmTextArea,
    LmButton,
    LmDatatableWithModalSelector,
    LmSuperPowerSelectV2,
    LmTreeSelect,
    LmProfileCropper,
    LmQmsFormBuilder,
    LmFormSubtitlesBuilderUi,
    LmTextNumberEditorTextAreaPasswordBuilderUi,
    LmFormEmptySpaceBuilderUi,
    LmFormSeparatorBuilderUi,
    LmButtonV2,
    LmEmailInputBuilderUi,
    LmSelectBuilderUi,
    LmColorPickerBuilderUi,
    draggable,
    LmPageBreakBuilderUi,
    LmQmsButton,
    LmQmsButtonBuilderUi,
    LmQmsNumberInput,
    LmQmsNumberInputBuilderUi,
    LmQmsWatch,
    LmQmsWatchBuilderUi
  },
  props: {
    isOnEditMode: {
      type: Boolean,
      default: false
    },
    frontendRouteToRedirectAfterCreated: {
      type: String,
      required: true
    },
    serviceEndpoint: {
      type: String,
      required: true
    }
  },
  data () {
    return {
      isLoading: false,
      isImageLoadedToBeCrop: false,
      imageToCrop: '',
      // Definición de componentes custom que se van a usar en lmFormBuilderUi
      useCustomComponents: {
        disabledOption: 'Seleccione una opción',
        content: [
          { value: 'LmQmsNumberInput', text: '🔢  Teclado Numérico' },
          { value: 'LmQmsButton', text: '🔲 Botón' },
          { value: 'LmFormSeparator', text: '➖  Separador' },
          { value: 'LmFormEmptySpace', text: '↔ Espacio vacio' },
          { value: 'LmFormSubtitles', text: '📰  Subtítulo' },
          { value: 'LmQmsWatch', text: '⌚ Reloj' }
        ]
      },
      isEditable: true,

      form: {
        name: '',
        description: '',
        url: '',
        branchoffices: [],
        processes: [],
        logo: {},
        screens: [{
          title: this.$t('startup_screen'),
          formElements: []
        }],
        validations: {}
      },
      deleted: false,
      modes: {
        selected: 'edit',
        editView: true
      },
      componentsOptions: {
        content: []
      },
      availableProcesses: [],
      isProcessing: false
    }
  },
  validations: {
    form: {
      name: { required }
    }
  },
  computed: {
    logoPath () {
      if (this.form?.logo?.path) {
        return process.env.VUE_APP_API_URL_STATIC_ASSETS + this.form.logo.path
      }
      return null
    }
  },
  methods: {
    v (position) {
      return _.get(_.cloneDeep(this.$v), position)
    },
    validateForm (validation) {
      validation.$touch()
      if (validation.$error) {
        this.lmToastDangerMessage(this.$t('form_with_errors'), 'Error')
        throw new Error('validation error')
      } else {
        if (validation.$pending || validation.$error) {
          throw new Error('validation error')
        }
      }
    },
    async onSubmit () {
      try {
        await this.validateForm(this.$v)
        this.isProcessing = true
        if (this.isOnEditMode) {
          await commonsApi.axiosPutWrapper(`/${this.serviceEndpoint}/${this.$route.params.id}`, this.form)
        } else {
          const res = await commonsApi.axiosPostWrapper(`/${this.serviceEndpoint}`, this.form)
          this.$router.replace(`${this.frontendRouteToRedirectAfterCreated}${res.data._id}`)
        }
        this.lmToastSuccessMessage(
          `${this.$t('saved_successfully')} '${this.form.name}'`,
          `${this.$t('action_done_successfully')}`
        )
      } catch (error) {
        console.log(error)
      } finally {
        this.isProcessing = false
      }
    },
    onCancel () {
      this.$router.go(-1)
    },
    async onDelete () {
      try {
        this.isProcessing = true
        await commonsApi.axiosDeleteWrapper(`/${this.serviceEndpoint}/delete/${this.$route.params.id}`)
        this.lmToastSuccessMessage(
          `${this.$t('was_successfully_deleted')} ${this.name}`,
          `${this.$t('action_done_successfully')}`
        )
        this.onCancel()
      } catch (error) {
        console.log(error)
      } finally {
        this.isProcessing = false
      }
    },
    async onReactivate () {
      try {
        this.isProcessing = true
        await commonsApi.axiosPutWrapper(`/${this.serviceEndpoint}/reactivate/${this.$route?.params?.id}`)
        this.lmToastSuccessMessage(`${this.$t('was_successfully_reactivated')}`, `${this.$t('it_was_successfully_reactivated')}`)
        this.onCancel()
      } catch (error) {
        console.log(error)
      } finally {
        this.isProcessing = false
      }
    },
    async loadData () {
      const res = await commonsApi.axiosGetWrapper(`/${this.serviceEndpoint}/${this.$route.params.id}`)
      this.form = res.data
      const processes = await commonsApi.axiosGetWrapper('/qmsprocesses/all')
      this.availableProcesses = processes.data.map(p => {
        return {
          value: p._id,
          text: p.name
        }
      })
    },

    title (component) {
      if (this.componentsOptions?.content?.length) {
        const componentLabel = component?.componentProps?.label
        const componentValue = component?.componentProps?.value
        const componentText = component?.componentProps?.text
        const componentName = component?.componentProps?.name
        const { text } = this.componentsOptions.content.find(e => e.value === component?.componentName)
        let moreInfo = ''
        if (componentLabel) {
          moreInfo += ' - ' + componentLabel
        } else if (componentValue) {
          moreInfo += ' - ' + componentValue
        } else if (componentText) {
          moreInfo += ' - ' + componentText
        } else if (componentName) {
          moreInfo += ' - ' + componentName
        }
        return text + moreInfo
      } else {
        return ''
      }
    },
    shouldCreatePortal (componentName) {
      return componentName !== 'LmComment'
    },
    openEditFormElement (index) {
      this.$root.$emit('bv::toggle::collapse', `collapse-${index}`)
    },
    selectorElementForm (componentName, elementIndex, screensIndex) {
      let formElement = {}

      let formObjectToSendToServerProperty = this.nameFormatter(this.$t(componentName)) + '_' + this.getRandomName()

      switch (componentName) {
        case 'LmQmsNumberInput':
          formElement = {
            id: this.generateId(),
            class: 'col-12 col-md-12',
            componentName,
            formObjectToSendToServerProperty: formObjectToSendToServerProperty,
            componentProps: {
              label: this.$t('title'),
              placeholder: '',
              width: '',
              align: 'justify-center',
              isVisible: true,
              validations: {
                minLength: 1,
                maxLength: 8
              },
              buttonColor: '#000',
              buttonBgColor: '#fff',
              deleteButtonColor: '#fff',
              deleteButtonBgColor: '#4a86e8',
              backspaceButtonColor: '#fff',
              backspaceButtonBgColor: '#4a86e8',
              okButton: {
                id: this.generateId(),
                class: 'col-12',
                componentName: 'LmQmsButton',
                componentProps: {
                  action: 'gotoscreen',
                  name: this.$t('accept'),
                  selectedScreen: '',
                  selectedProcess: '',
                  buttonColor: '#fff',
                  buttonBgColor: '#4a86e8',
                  buttonAlign: 'right',
                  currentScreenId: this.form.screens[screensIndex].id
                }
              }
            }
          }
          break
        case 'LmQmsWatch':
          formElement = {
            id: this.generateId(),
            class: 'col-12 col-md-12',
            componentName,
            componentProps: {
              label: this.$t('title'),
              dateFormat: 'DD-MM-YYYY',
              placeholder: 'HH:MM:ss',
              align: 'center',
              isVisible: true
            }
          }
          break
        case 'LmFormSubtitles':
          formElement = {
            id: this.generateId(),
            class: 'col-12 col-md-12',
            componentName,
            componentProps: {
              isVisible: true,
              width: '',
              align: 'justify-center',
              color: '#000000',
              text: this.$t('subtitle_placeholder_example')
            }
          }
          break
        case 'LmFormEmptySpace':
          formElement = {
            id: this.generateId(),
            class: 'col-12 col-md-6',
            componentName,
            componentProps: {
              isVisible: true
            }
          }
          break
        case 'LmFormSeparator':
          formElement = {
            id: this.generateId(),
            class: 'col-12 mt-3',
            componentName,
            componentProps: {
              isVisible: true
            }
          }
          break
        case 'LmQmsButton':
          formElement = {
            id: this.generateId(),
            class: 'col-12 col-md-3',
            componentName,
            componentProps: {
              action: 'gotoscreen',
              name: this.$t('button'),
              selectedScreen: '',
              selectedProcess: '',
              buttonColor: '#fff',
              buttonBgColor: '#4a86e8',
              buttonAlign: 'center',
              currentScreenId: this.form.screens[screensIndex].id
            }
          }
          break
      }

      this.form.screens[screensIndex].formElements.splice(elementIndex, 1, formElement)
    },
    addFormElement (screensIndex, elementIndex) {
      this.selectorElementForm('LmQmsNumberInput', elementIndex, screensIndex)
    },
    validationsChangesHandler (payload) {
      let newValidation = {}
      const formValidationHasItem = Object.keys(this.form.validations).length
      if (formValidationHasItem) {
        for (const validation in this.form.validations) {
          const existFormObjectToSendToServerPropertyForValidation = this.form.formElements.find((el) => el.formObjectToSendToServerProperty === validation)
          if (existFormObjectToSendToServerPropertyForValidation) {
            newValidation = { ...newValidation, [validation]: this.form.validations[validation] }
          }
        }
        this.form.validations = { ...newValidation, ...payload }
      } else {
        this.form.validations = { ...this.form.validations, ...payload }
      }
    },
    inputHandler (event, index, subindex) {
      this.form.screens[index].formElements[subindex] = event
    },
    onAddBranchOffices (items) {
      try {
        if (items?.length) {
          this.form.branchoffices = items
          // this.blueprintChange = true
        }
      } catch (error) {
        console.log(error)
      }
    },

    onRemoveBranchOffices (items) {
      try {
        if (items?.length) {
          const idsToRemove = items.map(i => i.id)
          this.form.branchoffices = this.form.branchoffices.filter(obj => !idsToRemove.includes(obj.id))
          // this.blueprintChange = true
        }
      } catch (error) {
        console.log(error)
      }
    },

    onAddProcesses (items) {
      try {
        if (items?.length) {
          this.form.processes.push(...items)
          // this.blueprintChange = true
        }
      } catch (error) {
        console.log(error)
      }
    },

    onRemoveProcesses (items) {
      try {
        if (items?.length) {
          const idsToRemove = items.map(i => i.id)
          this.form.processes = this.form.processes.filter(obj => !idsToRemove.includes(obj.id))
          // this.blueprintChange = true
        }
      } catch (error) {
        console.log(error)
      }
    },

    addScreenElement () {
      this.form.screens.push({
        id: this.nameFormatter('screen_' + this.getRandomName()),
        title: `Pantalla ${this.form.screens.length + 1}`,
        formElements: []
      })
    },

    removeScreenElement (elementIndex) {
      this.form.screens.splice(elementIndex, 1)
    },

    removeQmsFormElement (index, subindex) {
      this.form.screens[index].formElements.splice(subindex, 1)
    },

    cropImage (ref) {
      this.$refs[ref].crop()
      this.$refs[ref].submit()
    },

    closeCropper (id, ref) {
      this.$forceUpdate()
      this.$bvModal.hide(id)
      this.imageToCrop = ''
      this.$refs[ref].reset()
    },

    onRemoveLogo () {
      this.form.logo = {
        path: null
      }
    }
  },
  async created () {
    try {
      this.isLoading = true
      if (this.isOnEditMode) {
        await this.loadData()
      }
    } catch (error) {
      console.log(error)
    } finally {
      this.isLoading = false
    }
  }
}
</script>

<style lang="sass" scoped>
  .formbuilder-component-section, .formbuilder-preview-section
    overflow: auto
    max-height: 600px

  .overlay-image
    .empty-logo
      margin-top: 14px
      height: 38px
      background-color: #eaeaea
      border-radius: 5px
      border: 2px dashed #d1d0d0
      p:focus-visible
        outline: none
    .img-wrap
      margin-top: 12px
      position: relative
      cursor: pointer
    .img-preview
      max-width: auto
      height: 100px
    .img-description-layer
      position: absolute
      top: 0
      bottom: 0
      left: 0
      right: 0
      border-radius: 5px
      background: var(--app-accent-color)
      color: #fff
      visibility: hidden
      opacity: 0
      display: flex
      align-items: center
      justify-content: center
      transition: opacity .2s, visibility .2s
    .img-wrap:hover .img-description-layer
      visibility: visible
      opacity: 1
    .img-description
      margin-bottom: 0
      transition: .2s
      transform: translateY(1em)
      text-transform: uppercase
    .img-wrap:hover .img-description
      transform: translateY(0)
</style>
